import React, { useState } from "react"
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api"
import SbEditable from "storyblok-react"

const googleMapStyles = require("./GoogleMapStyles.json")

const containerStyle = {
  width: "100%",
  height: "470px",
}

const center = {
  lat: 27.284630057741364,
  lng: 18.856190399638727,
}

const positions = {
  'UK': {lat: 51.94746200050524,lng: -0.27923497203311737,},
  'US': {lat: 40.090821289826714,lng: -82.99889443673811,},
  'ES': {lat: 40.41617337414698,lng: -3.699564289912477,},
  'NZ': {lat: -41.30340304260371,lng: 173.23266202905887,},
  'AU': {lat: -33.7989268,lng: 151.2821792,},
  'ZA': {lat: -25.806709,lng: 28.346930,},
}

const divStyle = {
  background: `white`,
  border: `1px solid #ccc`,
  padding: 15,
  width: '300px'
}

const Location = ({position, children, setActiveWindow, activeWindow}) => {
  return (
    <>
      <Marker
        position={positions[position]}
        clickable={true}
        onClick={() => setActiveWindow(position)}
        icon={{
          url:
            "https://a.storyblok.com/f/143052/x/c2e5eef11e/map-marker-2.svg",
        }}
      />
      {/* {activeWindow === position && 
        <InfoWindow
          position={positions[position]}
          onCloseClick={() => setActiveWindow()}
        >
          <div style={divStyle}>
            {children}
          </div>
        </InfoWindow>
      } */}
    </>
  )
}

const GoogleMaps = ({ blok }) => {
  const [activeWindow, setActiveWindow] = useState()
  return (
    <SbEditable content={blok} key={blok._uid}>
        <LoadScript preventGoogleFontsLoading googleMapsApiKey="AIzaSyAx4g1lzAihPkg3bHzfx139PHx9-30nGrI">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={2}
            onClick={() => setActiveWindow()}
            options={{ 
              styles: googleMapStyles,
              mapTypeControl: false,
              streetViewControl: false,
            }}
          >
            <Location position="UK" setActiveWindow={setActiveWindow} activeWindow={activeWindow}>
              <h1>Govox UK</h1>
              <p>
                30 Market Pl,<br/>
                Hitchin SG5 1DY,<br/>
                United Kingdom<br/>
              </p>
              <p>Ph: <a href="tel:0207 411 9042" className="text-teal hover:text-darkteal duration-300">0207 411 9042</a></p>
              <p>E: <a href="mailto:hello@govox.com" className="text-teal hover:text-darkteal duration-300">hello@govox.com</a></p>
            </Location>
            <Location position="US" setActiveWindow={setActiveWindow} activeWindow={activeWindow}>
              <h1>Govox US</h1>
              <p>
                6155 Huntley Rd.,<br/>
                Suite E Columbus,<br/>
                Ohio 43229,<br/>
                United States<br/>
              </p>
              <p>E: <a href="mailto:hello.us@govox.com" className="text-teal hover:text-darkteal duration-300">hello.us@govox.com</a></p>
            </Location>
            <Location position="ES" setActiveWindow={setActiveWindow} activeWindow={activeWindow}>
              <h1>Govox ES</h1>
              <p>
                Calle Echegaray,<br/>
                3, 3º Izq A,<br/>
                Madrid 28014,<br/>
                Spain<br/>
              </p>
              <p>E: <a href="mailto:hello.es@govox.com" className="text-teal hover:text-darkteal duration-300">hello.es@govox.com</a></p>
            </Location>
            <Location position="AU" setActiveWindow={setActiveWindow} activeWindow={activeWindow}>
              <h1>Govox AU</h1>
              <p>
                54 West Esplanade,<br/>
                Sydney 2095,<br/>
                New South Wales,<br/>
                Australia<br/>
              </p>
              <p>Ph: <a href="tel:+61 421 996 747" className="text-teal hover:text-darkteal duration-300">+61 (0) 421 996 747</a></p>
              <p>E: <a href="mailto:hello.aus@govox.com" className="text-teal hover:text-darkteal duration-300">tim.gill@govox.com</a></p>
            </Location>
            <Location position="NZ" setActiveWindow={setActiveWindow} activeWindow={activeWindow}>
              <h1>Govox NZ</h1>
              <p>
                18 Exeter Street,<br/>
                Stoke,<br/>
                Nelson 7011,<br/>
                New Zealand<br/>
              </p>
              <p>Ph: <a href="tel:+61 (0) 421 179 986" className="text-teal hover:text-darkteal duration-300">+61 (0) 421 179 986</a></p>
              <p>E: <a href="mailto:hello.nz@govox.com" className="text-teal hover:text-darkteal duration-300">hello.nz@govox.com</a></p>
            </Location>
            <Location position="ZA" setActiveWindow={setActiveWindow} activeWindow={activeWindow}>
              <h1>Govox ZA</h1>
              <p>
                148 Olympus Country Estate,<br/>
                Olympus 0081,<br/>
                Pretoria,<br/>
                South Africa<br/>
              </p>
              <p>Ph: <a href="tel:+27 83 232 6998" className="text-teal hover:text-darkteal duration-300">+27 (0) 83 232 6998</a></p>
              <p>E: <a href="mailto:matthew.ash@govox.com" className="text-teal hover:text-darkteal duration-300">matthew.ash@govox.com</a></p>
            </Location>
          </GoogleMap>
        </LoadScript>
    </SbEditable>
  )
}

export default GoogleMaps
